(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["christmas-deals"] && !Shopify.designMode) return;
  try {
    
  class ChristmasCountdown extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline);
      if (Number.isNaN(this.deadline)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const left = Math.max(0, this.deadline - Date.now());
      if (left === 0) {
        clearInterval(this.timer);
        this.querySelector('.christmas-deals__timer')?.setAttribute('hidden', '');
        this.querySelector('.christmas-deals__countdown-label')?.setAttribute('hidden', '');
        this.querySelector('.christmas-deals__expired')?.removeAttribute('hidden');
        return;
      }
      const parts = {
        days: Math.floor(left / 86400000),
        hours: Math.floor(left / 3600000) % 24,
        minutes: Math.floor(left / 60000) % 60,
        seconds: Math.floor(left / 1000) % 60,
      };
      for (const [unit, value] of Object.entries(parts)) {
        const el = this.querySelector(`[data-unit="${unit}"]`);
        if (el) el.textContent = String(value).padStart(2, '0');
      }
    }
  }

  if (!customElements.get('christmas-countdown')) customElements.define('christmas-countdown', ChristmasCountdown);

  document.addEventListener('click', (event) => {
    const arrow = event.target instanceof Element && event.target.closest('.christmas-deals__arrow');
    if (!arrow) return;
    const track = arrow.parentElement.querySelector('.christmas-deals__track');
    track.scrollBy({ left: Number(arrow.dataset.dir) * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
